import React, { useMemo } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import Logo1 from "../assets/images/logo-footer.svg";
import Logo from "../assets/images/logo.png";

import Facebook from "../assets/images/facebook.svg";
import X from "../assets/images/x.svg";
import Linkedin from "../assets/images/linkedin.svg";
import Instagram from "../assets/images/instagram.svg";
import Youtube from "../assets/images/youtube.svg";
import { usePageContent } from "../hooks/usePageContent";
import { ASSETS_URL } from "../api/constants";

function Footer() {
  const { content } = usePageContent("footer");

  // Parse footer_section data
  const footerData = useMemo(() => {
    if (!content?.footer_section) return null;
    try {
      return JSON.parse(content.footer_section);
    } catch (error) {
      console.error("Error parsing footer_section:", error);
      return null;
    }
  }, [content]);

  // Default values
  const mainLogo = footerData?.main_logo
    ? `${ASSETS_URL}${footerData.main_logo}`
    : Logo;
  const bottomLogo = footerData?.bottom_logo
    ? `${ASSETS_URL}${footerData.bottom_logo}`
    : Logo1;
  const facebookUrl = footerData?.facebook_url || "/";
  const twitterUrl = footerData?.twitter_url || "/";
  const linkedinUrl = footerData?.linkedin_url || "/";
  const instagramUrl = footerData?.instagram_url || "/";
  const youtubeUrl = footerData?.youtube_url || "/";
  const menuItems = footerData?.menu_items || [];
  const copyrightText = footerData?.footer_copyright_text || "";
  const address = footerData?.address || "";

  // Split menu items into two groups (first group ends at Get Prequalified)
  const firstMenuGroup = menuItems.slice(0, 7);
  const secondMenuGroup = menuItems.slice(7);
  return (
    <>
      <footer className="common-padding">
        <Container>
          <div className="footer-top">
            <Link to={"/"}>
              <img width={160} className="footer-logo" src={mainLogo} alt="" />
            </Link>
            <ul>
              <li>
                <a
                  href={facebookUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Facebook"
                >
                  <img src={Facebook} alt="" />
                </a>
              </li>
              <li>
                <a
                  href={twitterUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Twitter"
                >
                  <img src={X} alt="" />
                </a>
              </li>
              <li>
                <a
                  href={instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Instagram"
                >
                  <img src={Instagram} alt="" />
                </a>
              </li>
              <li>
                <a
                  href={youtubeUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Youtube"
                >
                  <img src={Youtube} alt="" />
                </a>
              </li>
              <li>
                <a
                  href={linkedinUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Linkedin"
                >
                  <img src={Linkedin} alt="" />
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-mid">
            <ul>
              {firstMenuGroup.map((item, index) => (
                <li key={index}>
                  <a href={item.link} target="_blank" rel="noopener noreferrer">
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
            <ul>
              {secondMenuGroup.map((item, index) => (
                <li key={index}>
                  <a href={item.link} target="_blank" rel="noopener noreferrer">
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="footer-bottom">
            <div className="footer-bottom-left">
              {copyrightText && (
                <div dangerouslySetInnerHTML={{ __html: copyrightText }} />
              )}
            </div>
            <div className="footer-bottom-right">
              
              {address ? (
                <div dangerouslySetInnerHTML={{ __html: address }} />
              ) : (
                <address>
                  <p>Arika &amp; Company Advocates</p>
                  <p>Mbandu Complex, 4th Floor</p>
                  <p>Langata Road-Bomas, Opposite Galleria Mall</p>
                  <p>P.O BOX 13651-00100, Nairobi, Kenya</p>
                </address>
              )}
            </div>
          </div>
        </Container>
      </footer>
    </>
  );
}
export default Footer;
